import { DataProps } from '../types/boardTypes';

const initialData:DataProps = {
  tasks: {
    'task-1': { id: 'task-1', title: 'Take out the garbage', date:'11-07-2023', attachments:['aasdf', 'asdfsd'] },
    'task-2': { id: 'task-2', title: 'Watch my favorite show', coverColor: '#FF00004A' },
    'task-3': { id: 'task-3', title: 'Charge my phone',
      labelColor: '#5678FF',
      checklist: [
        {
          id: 'checklist-1',
          title: 'Checklist 1',
          entries: [
            {
              id: 'checklist-1-entry-1',
              title: 'Checklist 1 Entry 1',
              checked: true,
            },
            {
              id: 'checklist-1-entry-2',
              title: 'Checklist 1 Entry 2',
              checked: true,
            },
          ],
        },
        {
          id: 'checklist-2',
          title: 'Checklist 2',
          entries: [
            {
              id: 'checklist-2-entry-1',
              title: 'Checklist 2 Entry 1',
              checked: true,
            },
            {
              id: 'checklist-2-entry-2',
              title: 'Checklist 2 Entry 2',
              checked: true,
            },
          ],
        },
      ],
    },
    'task-4': { 
      id: 'task-4',
      title: 'Cook dinner',
      cover: 'https://cdn.pixabay.com/photo/2018/03/11/23/59/sunset-3218412_640.jpg',
      checklist: [
        {
          id: 'checklist-1',
          title: 'Checklist 1',
          entries: [
            {
              id: 'checklist-1-entry-1',
              title: 'Checklist 1 Entry 1',
              checked: false,
            },
            {
              id: 'checklist-1-entry-2',
              title: 'Checklist 1 Entry 2',
              checked: true,
            },
          ],
        },
        {
          id: 'checklist-2',
          title: 'Checklist 2',
          entries: [
            {
              id: 'checklist-2-entry-1',
              title: 'Checklist 2 Entry 1',
              checked: true,
            },
            {
              id: 'checklist-2-entry-2',
              title: 'Checklist 2 Entry 2',
              checked: true,
            },
          ],
        },
      ],
    },
    'task-13': { id: 'task-13', title: 'Change language to ukrainian', label: 'Urgent', labelColor: '#FF0000', content:'blah', date:'11-08-2023' },
    'task-14': { id:'task-14', title: 'Перевірити виробництво' },
    'task-15': { id:'task-15', title: 'Проконтролювати процес видачі замовлення', coverColor: '#FDFBC8' },
    'task-16': { id: 'task-16', title: 'Випрасувати 5 речей', date:'10-1-2023', checklist: [
      {
        id: 'checklist-1',
        title: 'Checklist 1',
        entries: [
          {
            id: 'checklist-1-entry-1',
            title: 'Checklist 1 Entry 1',
            checked: false,
          },
          {
            id: 'checklist-5-entry-5',
            title: 'Checklist 5 Entry 5',
            checked: false,
          },
          {
            id: 'checklist-1-entry-2',
            title: 'Checklist 1 Entry 2',
            checked: true,
          },
        ],
      },
      {
        id: 'checklist-2',
        title: 'Checklist 2',
        entries: [
          {
            id: 'checklist-2-entry-1',
            title: 'Checklist 2 Entry 1',
            checked: true,
          },
          {
            id: 'checklist-2-entry-2',
            title: 'Checklist 2 Entry 2',
            checked: true,
          },
        ],
      },
    ] },
    'task-17': { id: 'task-17', title: 'Відправити 3 замовлення', labelColor: '#BCEEF9', attachments:['asf'], date:'11-10-2023' },
    'task-18': { id: 'task-18', content:'Sfsfsdsf', title: 'Зробити переоблік', attachments:['asf'], date:'11-11-2023' },
    'task-19': { id: 'task-19', labelColor:'blue', label:'Urgent', coverColor:'coral', cover:'https://img.freepik.com/free-vector/linear-flat-abstract-lines-pattern_23-2148939520.jpg', title: 'Випрасувати 5 речей', content:'Fsdfsa', checklist: [
      {
        id: 'checklist-1',
        title: 'Checklist 1',
        entries: [
          {
            id: 'checklist-1-entry-1',
            title: 'Checklist 1 Entry 1',
            checked: true,
          },
          {
            id: 'checklist-5-entry-5',
            title: 'Checklist 5 Entry 5',
            checked: true,
          },
          {
            id: 'checklist-1-entry-2',
            title: 'Checklist 1 Entry 2',
            checked: true,
          },
        ],
      },
      {
        id: 'checklist-2',
        title: 'Checklist 2',
        entries: [
          {
            id: 'checklist-2-entry-1',
            title: 'Checklist 2 Entry 1',
            checked: true,
          },
          {
            id: 'checklist-2-entry-2',
            title: 'Checklist 2 Entry 2',
            checked: true,
          },
        ],
      },
    ] },
  },
  columns: {
    'column-1': {
      id: 'column-1',
      title: 'Потрібно зробити',
      taskIds: ['task-14', 'task-15'],
    },
    'column-2': {
      id: 'column-2',
      title: 'В процессі',
      taskIds: ['task-16', 'task-17'],
    },
    'column-3': {
      id: 'column-3',
      title: 'На перевірці',
      taskIds: ['task-18'],
    },
    'column-4': {
      id: 'column-4',
      title: 'Виконано',
      taskIds: ['task-19'],
    },
  },
  columnOrder: ['column-1', 'column-2', 'column-3', 'column-4'],
};
export default initialData;